import type { AuthenticatedUserContract, Locale } from "@chams-pay/contracts";
import { operationsMessages, translate } from "@chams-pay/contracts";
import { FileBarChart, Landmark, LayoutDashboard, UsersRound, type LucideIcon } from "lucide-react";

export type WorkspaceScreen = "dashboard" | "students" | "instruments" | "reports" | "settings";

export interface WorkspaceNavItem {
  readonly id: WorkspaceScreen;
  readonly title: string;
  readonly icon: LucideIcon;
  /** Screens that read live server state are unavailable while offline. */
  readonly onlineOnly: boolean;
}

/**
 * One navigation model for both presentations. Role gating lives here so the
 * desktop sidebar and the mobile tab bar can never drift apart.
 */
export function workspaceNavigation(
  locale: Locale,
  _user: AuthenticatedUserContract | null,
): readonly WorkspaceNavItem[] {
  const operations = operationsMessages(locale);
  return [
    {
      id: "dashboard",
      title: operations.navDashboard,
      icon: LayoutDashboard,
      onlineOnly: true,
    },
    {
      id: "students",
      title: translate(locale, "nav.students"),
      icon: UsersRound,
      onlineOnly: false,
    },
    {
      id: "instruments",
      title: operations.navInstruments,
      icon: Landmark,
      onlineOnly: true,
    },
    { id: "reports", title: operations.navReports, icon: FileBarChart, onlineOnly: true },
  ];
}

export function screenTitle(
  screen: WorkspaceScreen,
  locale: Locale,
  user: AuthenticatedUserContract | null,
): string {
  const match = workspaceNavigation(locale, user).find((item) => item.id === screen);
  return match?.title ?? translate(locale, "settings.title");
}
